// Inline SVG icons. Stroke-based, currentColor for theming.
// Sized via parent (set width/height on the wrapper).

const svg = (path: string, vb = '0 0 24 24') =>
  `<svg viewBox="${vb}" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${path}</svg>`;

export const icons = {
  // Track icons
  vocab: svg('<rect x="3" y="4" width="18" height="16" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/><line x1="3" y1="15" x2="21" y2="15"/>'),
  grammar: svg('<path d="M14 4v3a2 2 0 0 0 2 2h3v6h-3a2 2 0 0 0-2 2v3h-6v-3a2 2 0 0 0-2-2H3v-6h3a2 2 0 0 0 2-2V4z"/>'),
  pron: svg('<path d="M3 12h2l2-6 4 12 3-9 2 6 2-3h3"/>'),
  listen: svg('<path d="M3 13a9 9 0 0 1 18 0v5a2 2 0 0 1-2 2h-2v-7h4M3 13v5a2 2 0 0 0 2 2h2v-7H3"/>'),
  task: svg('<path d="M14 3l7 7-11 11H3v-7z"/><path d="M14 3l7 7"/>'),

  // Nav icons
  home: svg('<path d="M3 11l9-8 9 8M5 10v10h14V10"/>'),
  path: svg('<path d="M5 21l14-14M9 5h10v10"/>'),
  settings: svg('<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"/>'),
  check: svg('<polyline points="20 6 9 17 4 12"/>'),
  anchor: svg('<circle cx="12" cy="5" r="3"/><line x1="12" y1="22" x2="12" y2="8"/><path d="M5 12H2a10 10 0 0 0 20 0h-3"/>'),
  bulb: svg('<path d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7c1 .7 1.5 1.6 1.5 2.6V18h5v-.7c0-1 .5-2 1.5-2.6A7 7 0 0 0 12 2z"/>'),
  play: svg('<polygon points="6 4 20 12 6 20 6 4"/>'),
  volume: svg('<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/>'),
};

export type IconName = keyof typeof icons;
